module.exports = __webpack_public_path__ + "static/media/191EC241.6dd871d9.jpg";